import { Tenant } from "@opendash/core/dist/types-generated";
import { useTranslation } from "@opendash/i18n";
import { Button, List } from "antd";
import Parse from "parse";
import React from "react";
import { SetupPermission } from "../types";
type PermissionSetupListProps = React.PropsWithChildren & {
  permissions: SetupPermission[];
  tenants?: Tenant[];
};
const PermissionSetupList = ({
  permissions,
  tenants,
}: PermissionSetupListProps) => {
  const [logs, setLogs] = React.useState<string[]>([]);
  const t = useTranslation();
  const createForTenants = (item, tenants) => {
    createPermissionForTenants(item, tenants)
      .then(() => {
        setLogs((prev) => [...prev, `Created permission: ${item.key}`]);
      })
      .catch((err) => {
        setLogs((prev) => [
          ...prev,
          `Error creating permission: ${item.key} - ${err.message}`,
        ]);
      });
  };
  const createForAdmin = (item, tenants) => {
    createPermission(item)
      .then(() => {
        setLogs((prev) => [...prev, `Created permission: ${item.key}`]);
      })
      .catch((err) => {
        setLogs((prev) => [
          ...prev,
          `Error creating permission: ${item.key} - ${err.message}`,
        ]);
      });
  };

  return (
    <>
      {logs.length > 0 && (
        <pre style={{ background: "#ddd", border: "1px solid grey" }}>
          {logs.map((log) => (
            <>
              {log}
              <br />
            </>
          ))}
        </pre>
      )}

      <List
        footer={
          <Button
            type="primary"
            onClick={() => {
              permissions.forEach((item) => {
                createPermission(item)
                  .then(() => {
                    setLogs((prev) => [
                      ...prev,
                      `Created permission: ${item.key}`,
                    ]);
                  })
                  .catch((err) => {
                    setLogs((prev) => [
                      ...prev,
                      `Error creating permission: ${item.key} - ${err.message}`,
                    ]);
                  });
              });
            }}
          >
            Create all for od-admin
          </Button>
        }
        itemLayout="horizontal"
        dataSource={permissions}
        renderItem={(item) => (
          <List.Item
            actions={[
              <>
                {!item.adminOnly && (
                  <a
                    key="for-all-tenants"
                    onClick={() => {
                      createForTenants(item, tenants);
                    }}
                  >
                    create for tenants
                  </a>
                )}
              </>,
              <a
                key="create-without-tenants"
                onClick={() => {
                  createForAdmin(item, tenants);
                }}
              >
                create for admin
              </a>,
            ]}
          >
            <List.Item.Meta
              title={item.label ? t(item.label) : item.key}
              description={
                item.description
                  ? t(item.description)
                  : `${item.label} (${item.key})`
              }
            />
          </List.Item>
        )}
      />
    </>
  );
};
async function createPermission(perm: SetupPermission) {
  const pPerm = new Parse.Object("OD3_Permission");
  Object.keys(perm).forEach((key) => {
    if (key === "ACL") return; // Skip ACL for now
    pPerm.set(key, perm[key]);
  });
  if (perm.ACL) {
    pPerm.setACL(new Parse.ACL(perm.ACL));
  }

  await pPerm.save(null, { useMasterKey: true });
}

async function createPermissionForTenants(
  perm: SetupPermission,
  tenants: Tenant[]
) {
  const objects = [] as Parse.Object[];
  tenants.forEach(async (tenant) => {
    const pPerm = new Parse.Object("OD3_Permission");
    Object.keys(perm).forEach((key) => {
      if (key === "ACL") return; // Skip ACL for now
      pPerm.set(key, perm[key]);
    });
    if (perm.ACL) {
      pPerm.setACL(new Parse.ACL(perm.ACL));
    }
    pPerm.set("tenant", tenant);
    objects.push(pPerm);
  });
  await Parse.Object.saveAll(objects, { useMasterKey: true });
}

export default PermissionSetupList;
export type { PermissionSetupListProps };
